import { init } from '@sentry/react';
init({
  dsn: 'https://abad6af210b1f49ca865d35ebc7cfa45@o292676.ingest.us.sentry.io/4508557728612352',
  enabled: import.meta.env.PROD,
});
